/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ReverseGeocodingResult } from '../models/reverse-geocoding-result';

@Injectable({
  providedIn: 'root',
})
export class GeocodingService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getAddess
   */
  static readonly GetAddessPath = '/api/geocoding';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAddess()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAddess$Response(params?: {
    lat?: number;
    lng?: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<ReverseGeocodingResult>> {

    const rb = new RequestBuilder(this.rootUrl, GeocodingService.GetAddessPath, 'get');
    if (params) {
      rb.query('lat', params.lat, {});
      rb.query('lng', params.lng, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ReverseGeocodingResult>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAddess$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAddess(params?: {
    lat?: number;
    lng?: number;
    context?: HttpContext
  }
): Observable<ReverseGeocodingResult> {

    return this.getAddess$Response(params).pipe(
      map((r: StrictHttpResponse<ReverseGeocodingResult>) => r.body as ReverseGeocodingResult)
    );
  }

}
